import {
  Grid,
  Typography,
} from '@mui/material';

const NotFoundPage = () => (
  <Grid
    sx={{
      width: '100%',
      textAlign: 'center',
    }}
  >
    <Typography
      component="h1"
      variant="h1"
    >
      404
    </Typography>
    <Typography
      component="p"
      variant="body1"
    >
      Not Found
    </Typography>
  </Grid>
)

export default NotFoundPage;
